export const LOCATION_CARD_MIN_COLUMN_WIDTH = 260;
export const LOCATION_CARD_OFFSET_BETWEEN_COLUMNS = 32;
